/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import DashboardIcon from '@material-ui/icons/DashboardOutlined'
import AssessmentOutlinedIcon from '@material-ui/icons/AssessmentOutlined'
import SupervisorAccountOutlinedIcon from '@material-ui/icons/SupervisorAccountOutlined'
import PermIdentityOutlinedIcon from '@material-ui/icons/PermIdentityOutlined'
import CardTravelOutlinedIcon from '@material-ui/icons/CardTravelOutlined'
import AttachMoneyOutlinedIcon from '@material-ui/icons/AttachMoneyOutlined'
import HeadsetMicOutlinedIcon from '@material-ui/icons/HeadsetMicOutlined'
import FlagOutlinedIcon from '@material-ui/icons/FlagOutlined'
import LocalOfferOutlinedIcon from '@material-ui/icons/LocalOfferOutlined'

export default [
  {
    pages: [
      {
        title: 'Dashboard',
        href: '/Dashboard',
        icon: DashboardIcon
      },
      {
        title: 'Campaigns',
        href: '/campaigns',
        icon: FlagOutlinedIcon
      },
      {
        title: 'Analytics',
        href: '/analytics',
        icon: AssessmentOutlinedIcon
      },
      {
        title: 'Brands',
        href: '/brands',
        icon: LocalOfferOutlinedIcon
      },
      {
        title: 'Admins',
        href: '/admins',
        icon: SupervisorAccountOutlinedIcon
      },
      {
        title: 'Account',
        href: '/account',
        icon: PermIdentityOutlinedIcon
      },
      {
        title: 'Assets and Media',
        href: '/assets',
        icon: CardTravelOutlinedIcon
      },
      {
        title: 'Transactions',
        href: '/transactions',
        icon: AttachMoneyOutlinedIcon
      },
      {
        title: 'Support',
        href: '/supportcenter',
        icon: HeadsetMicOutlinedIcon
      }
    ]
  }
]
